import { Component, Input, inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-cal-com-widget',
  standalone: true,
  imports: [CommonModule],
  template: `<button type="button" (click)="redirectToCal()" class="button primary">
    <span>{{ buttonText }}</span>
  </button>`,
  styles: [
    `button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
      padding: 0.9rem 2rem;
      border-radius: 50px;
      background: var(--brand);
      color: #000;
      border: none;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s ease;
      width: 100%;
    }
    
    button:hover {
      filter: brightness(1.1);
      transform: translateY(-2px);
    }`
  ]
})
export class CalComWidgetComponent {
  @Input() buttonText: string = 'Prendre rendez-vous';
  @Input() calLink: string = 'https://cal.mesh-box.fr';
  @Input() username: string = 'ogirodin';
  @Input() eventType: string = '30min';
  
  private platformId = inject(PLATFORM_ID);
  
  public redirectToCal() {
    if (isPlatformBrowser(this.platformId)) {
      const fullUrl = `${this.calLink}/${this.username}/${this.eventType}`;
      window.location.href = fullUrl;
    }
  }
}